/**
 * "Out until Tue 20 Oct", from somebody's Outlook automatic replies (085).
 *
 * The day, not the hour: a scheduled absence ends at whatever time somebody
 * typed into Outlook, and "until 07:00" reads as precision the setting does
 * not have. No date at all means automatic replies are simply on.
 */
export function awayLabel(until: string | null | undefined, now: Date = new Date()): string {
  if (!until) return 'Out of office';
  const d = new Date(until);
  if (Number.isNaN(d.getTime())) return 'Out of office';
  const sameYear = d.getFullYear() === now.getFullYear();
  const day = d.toLocaleDateString(undefined, {
    weekday: 'short',
    day: 'numeric',
    month: 'short',
    ...(sameYear ? {} : { year: 'numeric' }),
  });
  return `Out of office until ${day}`;
}
